import { Project } from '../project/project';
import {TranslateService} from "@ngx-translate/core";

export interface Companies {
  Data: Company[];
  Count: number;
}

export interface Company {
  Id?: number;
  Uid?: string;
  SUid?: string;
  isChecked?: boolean;
  Project?: Project;
  ShortName?: string;
  Name1?: string;
  Name2?: string;
  Supplier?: string;
  Street?: string;
  ZipCode?: string;
  City?: string;
  Country?: string;
  POBox?: string;
  ZipCodePOBox?: string;
  CityPOBox?: string;
  Phone?: string;
  Fax?: string;
  Email?: string;
  Web?: string;
  IsInsolvent?: boolean;
  IsActive?: boolean;
  UsePOBoxAsAddress?: boolean;
  IsDeleted?: boolean;
  ViewPoint?: number;
  IsChecked?: boolean;
}

export function getCompanyInfo(c: Company, translateService: TranslateService) {
  if(c.IsDeleted) {
    return " " + translateService.instant("MM.general.deleted");
  }
  if(!c.IsActive || c.IsInsolvent) {
    return " " + translateService.instant("MM.general.inactive");
  }
  return "";
}
